import { openModal } from '@core/components/ModalStack';
import { Subject } from 'rxjs';
import { TwoFactorModalProps } from './TwoFactorModal';

export function openTwoFactorVerifyModal(props: Omit<TwoFactorModalProps, 'onVerified' | 'onCancel'>) {
  const obs$ = new Subject<string>();

  const onVerified = () => {
    obs$.next('VERIFIED');
    obs$.complete();
  };

  const onCancel = () => {
    obs$.next('');
    obs$.complete();
  };

  import('./TwoFactorModal').then(module => openModal(module.TwoFactorModal, { ...props, onVerified, onCancel }));

  return obs$;
}
